import { ComponentType, lazy, Suspense } from 'react';

import { Loading } from '@frontend/views';

const expectedErrors = [
  'Failed to fetch dynamically imported module', // Chrome
  'error loading dynamically imported module', // Firefox
];

export const loadComponent = <TModule,>(
  loadFn: () => Promise<TModule>,
  resolveComponent: (module: TModule) => ComponentType<any>,
) => {
  const LazyLoader = lazy(() => {
    return loadFn()
      .then((module) => ({ default: resolveComponent(module) }))
      .catch((e) => {
        console.warn('Error loading component:', e);

        if (
          e instanceof TypeError &&
          expectedErrors.find((expectedError) =>
            e.message.includes(expectedError),
          )
        ) {
          /*
           * This does not take user being offline into account. This is tested however
           * using browser throttling set to offline. Using that we get the correct behavior
           * of reloading -> app initializes -> app tries to preload routes -> fails.
           *
           * If this would fail we could end up in an infinite loop of reloading.
           */
          console.warn('Reloading page due to error loading component');
          window.location.reload();

          // reload() is happening instantly but we need to return a valid component
          // to avoid other errors like e.g compile errors here.
          return { default: () => <div /> };
        }

        throw e;
      });
  });

  return () => {
    return (
      <Suspense fallback={<Loading />}>
        <LazyLoader />
      </Suspense>
    );
  };
};
